import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Divider, List, ListItem, ListItemText } from '@mui/material';

import { pageInfo, searchPages } from '../../utils/page';
import { NavCollapse } from './NavCollapse';
import { NavListItem } from './NavListItem';

function SearchResults({ query, pageStatus, onNavigate }) {
	const results = searchPages(query);
	if (!results.length) {
		return (
			<List>
				<ListItem>
					<ListItemText secondary="No matching page" />
				</ListItem>
			</List>
		);
	}
	return (
		<List>
			{results.map(({ path, title, group }) => (
				<NavListItem
					key={path}
					path={path}
					text={title}
					group={group}
					status={pageStatus[path]}
					onNavigate={onNavigate}
				/>
			))}
		</List>
	);
}

SearchResults.propTypes = {
	query: PropTypes.string,
	pageStatus: PropTypes.objectOf(PropTypes.string),
	onNavigate: PropTypes.func,
};

export function NavList({ pageStatus, query = '', onNavigate }) {
	if (query.trim()) return <SearchResults query={query} pageStatus={pageStatus} onNavigate={onNavigate} />;

	return Object.keys(pageInfo).map((key) => {
		const page = pageInfo[key];
		if (page.hideFromNav) return null;
		return (
			<Fragment key={key}>
				<Divider />
				<List>
					{page.subPages ? (
						<NavCollapse
							title={page.title}
							subPages={page.subPages}
							pageStatus={pageStatus}
							onNavigate={onNavigate}
						/>
					) : (
						<NavListItem path={key} text={page.title} status={pageStatus[key]} onNavigate={onNavigate} />
					)}
				</List>
			</Fragment>
		);
	});
}

NavList.propTypes = {
	pageStatus: PropTypes.objectOf(PropTypes.string),
	query: PropTypes.string,
	onNavigate: PropTypes.func,
};
